// ============================================================
// TtrCardIcon — 기차 카드 face SVG 아이콘 (SEQ=10186 fine-tune ④)
//   SoT: H:\AI\AI_Setting\보드겜돌이\티켓투라이드.md §3-A-detail ⑨
//
//   9 SVG = Public Domain 자체 generation (Days of Wonder 원작 자산 미사용).
//   public/assets/ttr/cards/<color>-<theme>.svg
//
//   적용 영역:
//     - TtrHand.tsx  본인 카드 그리드 9칸 (.ttr-card-cell)
//     - TtrActionPanel.tsx  face-up 5슬롯 (.ttr-faceup-card)
//
//   graceful fallback: img.onerror 시 미표시(기존 색 chip + 텍스트 라벨만).
//   접근성: alt text = 카드 색·테마.
// ============================================================

import React, { useState } from 'react'

export type TtrCardColor =
  | 'RED' | 'ORANGE' | 'YELLOW' | 'GREEN' | 'BLUE'
  | 'PINK' | 'WHITE' | 'BLACK' | 'WILD'

// 색별 SVG 파일명 + alt text (한국어)
const CARD_ICON_MAP: Record<TtrCardColor, { src: string; alt: string }> = {
  RED:    { src: '/assets/ttr/cards/red-coal.svg',           alt: '빨강 (석탄차)' },
  ORANGE: { src: '/assets/ttr/cards/orange-tank.svg',        alt: '주황 (탱크차)' },
  YELLOW: { src: '/assets/ttr/cards/yellow-boxcar.svg',      alt: '노랑 (박스카)' },
  GREEN:  { src: '/assets/ttr/cards/green-caboose.svg',      alt: '초록 (캐부스)' },
  BLUE:   { src: '/assets/ttr/cards/blue-passenger.svg',     alt: '파랑 (객차)' },
  PINK:   { src: '/assets/ttr/cards/pink-freight.svg',       alt: '분홍 (화물차)' },
  WHITE:  { src: '/assets/ttr/cards/white-refrigerator.svg', alt: '하양 (냉동차)' },
  BLACK:  { src: '/assets/ttr/cards/black-hopper.svg',       alt: '검정 (호퍼차)' },
  WILD:   { src: '/assets/ttr/cards/wild-locomotive.svg',    alt: '와일드 (기관차)' },
}

export interface TtrCardIconProps {
  color:     string   // 'RED' | ... | 'WILD' (대문자, store/ticket 호환)
  className?: string
}

const TtrCardIcon: React.FC<TtrCardIconProps> = ({ color, className }) => {
  // SEQ=10188 P0 hot fix: color prop이 undefined일 수 있음 (face_up 빈 슬롯·myHand 빈 카드). 가드 추가.
  const key = (color ?? '').toUpperCase() as TtrCardColor
  const meta = CARD_ICON_MAP[key]
  const [failed, setFailed] = useState(false)

  if (!meta || failed) return null

  return (
    <img
      className={'ttr-card-icon' + (className ? ' ' + className : '')}
      src={meta.src}
      alt={meta.alt}
      onError={() => setFailed(true)}
      draggable={false}
    />
  )
}

export default TtrCardIcon
